import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=79aea5e8&scoped=true"
import script from "./myTask.vue?vue&type=script&lang=js"
export * from "./myTask.vue?vue&type=script&lang=js"
import style0 from "./myTask.vue?vue&type=style&index=0&id=79aea5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aea5e8",
  null
  
)

export default component.exports